/**
 * Header.js — Sticky top bar with logo, title, connection badge, and Register button
 */

import React from "react";
import StatusIndicator from "./StatusIndicator";

export default function Header({ connected, recordCount, onRegister }) {
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md
                       border-b border-slate-200/60 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16
                      flex items-center justify-between">

        {/* Left — logo + title */}
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-500 to-brand-700
                          flex items-center justify-center shadow-sm">
            <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
              <path d="M14 14h2v2h-2zM18 14h3M14 18h2M18 18h3v3M18 21h3"/>
            </svg>
          </div>
          <div>
            <h1 className="text-base font-bold text-slate-800 leading-tight tracking-tight">
              RFID Attendance Dashboard
            </h1>
            <p className="text-xs text-slate-400 font-medium">IoT Live Tracking System</p>
          </div>
        </div>

        {/* Right — scan count + register button + status */}
        <div className="flex items-center gap-3">
          <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5
                          rounded-full bg-brand-50 border border-brand-100">
            <span className="text-xs font-semibold text-brand-700">
              {recordCount} scan{recordCount !== 1 ? "s" : ""}
            </span>
          </div>

          <button
            onClick={onRegister}
            className="hidden sm:inline-flex btn-primary text-xs py-1.5"
          >
            <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="2.5">
              <line x1="12" y1="5" x2="12" y2="19"/>
              <line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Register Card
          </button>

          <StatusIndicator connected={connected} />
        </div>
      </div>
    </header>
  );
}
